// severity presentation helpers
export const SEVERITY = {
  critical: { label: "CRITICAL", color: "#FF0055", glow: "glow-critical", border: "border-l-critical", text: "text-critical" },
  high:     { label: "HIGH",     color: "#FF0055", glow: "glow-critical", border: "border-l-critical", text: "text-critical" },
  medium:   { label: "MEDIUM",   color: "#FFD600", glow: "glow-warning",  border: "border-l-warning",  text: "text-warning" },
  low:      { label: "LOW",      color: "#00E5FF", glow: "",              border: "border-l-info",     text: "text-info" },
};

export const CATEGORY_LABEL = {
  secret: "Exposed Secret",
  unsafe_query: "Unsafe Query",
  rls: "Missing Access Rules",
  misconfig: "Misconfiguration",
  injection: "Injection Risk",
  crypto: "Weak Crypto",
  auth: "Auth Flaw",
  access_control: "Access Control",
  ssrf: "SSRF",
  other: "Other",
};

export function scoreColor(score) {
  if (score >= 85) return "#00FF66";
  if (score >= 60) return "#FFD600";
  return "#FF0055";
}

export function scoreVerdict(score) {
  if (score >= 85) return "SHIP-READY";
  if (score >= 60) return "NEEDS WORK";
  if (score >= 30) return "AT RISK";
  return "DANGER ZONE";
}
